/*
 eslint-disable global-require, no-unused-vars
 */
import React from 'react';
import { render } from 'react-dom';
import { compose, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';
import rootReducer from './reducers/index';
import callUs from './reducers/reducer-call-us';
import errors from './reducers/reducer-error';
import notifier from './reducers/reducer-notifier';
import emailForm from './reducers/reducer-email-form';
import topicTree from './reducers/reducer-topic-select-result';
import App from './containers/App';
import fetchActiveCommunityUserCount from './actions/action-community-online';
import fetchChatEligibility from './actions/action-chat';
import getLocale from './actions/action-locale';
import { getHelpCenterAlerts } from './actions/index';
import Page from '../lib/page';
import { requestMetadata } from '../lib/griffin-metadata';

import fetchContactUsOnLogin from './actions/action-contact-us';
import { locationChecker } from './actions/action-contact-location';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
/* eslint-disable global-require,  import/no-extraneous-dependencies */

  // const { whyDidYouUpdate } = require('why-did-you-update');
  // whyDidYouUpdate(React);
  const createLogger = require('redux-logger');
  middlewares.push(createLogger());
  /* eslint-enable global-require,  import/no-extraneous-dependencies */
}
const store = createStore(rootReducer,
  undefined,
  compose(
    autoRehydrate(),
    applyMiddleware(...middlewares)),
  );

persistStore(store, {
  storage: asyncSessionStorage,
  blacklist: ['callUs', 'errors', 'notifier', 'searchResult', 'location', 'quickAnswers', 'emailNoIntent'],
}, () => {
  store.dispatch(getLocale());
  store.dispatch(fetchContactUsOnLogin());
});

store.dispatch(fetchActiveCommunityUserCount());
store.dispatch(getHelpCenterAlerts());

// Check Page path for loading data
store.dispatch(locationChecker());

const contactUsApp = () => render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);

requestMetadata().then(contactUsApp).catch(contactUsApp);
